/**
 * Home's Scheduled tab: dated items soonest first, under a header per time
 * bucket only when there is more than one bucket to tell apart.
 *
 * @module components/home/HomeScheduledList
 */
import { ListSection } from "../ui/list-section";
import { AGENDA_BUCKET_LABEL, agendaSections } from "./HomeAgenda.logic";
import { HomeListEmpty } from "./HomeListEmpty";
import type { HomeComingUpItem } from "./homeLogic";
import { HomeScheduledRow } from "./HomeScheduledRow";

export function HomeScheduledList({
  items,
  orgSegment,
  now,
  onPrepare,
}: {
  readonly items: ReadonlyArray<HomeComingUpItem>;
  readonly orgSegment: string;
  readonly now: number;
  readonly onPrepare: (prompt: string) => void;
}) {
  if (items.length === 0) return <HomeListEmpty>Nothing scheduled</HomeListEmpty>;
  const sections = agendaSections(items, now);
  const rows = (list: ReadonlyArray<HomeComingUpItem>) =>
    list.map((item) => <HomeScheduledRow key={item.id} item={item} orgSegment={orgSegment} now={now} onPrepare={onPrepare} />);
  if (sections.length === 1) return <ul className="flex flex-col">{rows(sections[0]!.items)}</ul>;
  return (
    <div className="flex flex-col">
      {sections.map((section) => (
        <ListSection
          key={section.bucket}
          label={AGENDA_BUCKET_LABEL[section.bucket]}
          count={section.items.length}
          urgent={section.bucket === "overdue"}
          defaultOpen={section.bucket !== "later"}
        >
          <ul>{rows(section.items)}</ul>
        </ListSection>
      ))}
    </div>
  );
}
